//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/VisualReporting.js";
import "../no/NXObject.js";
let d=[[[0,"Datatype",0,0],[0,"Description",1,0],[0,"HasUserSpecifiedValue",1,0],[0,"OperatorType",1,0],[0,"ParentCondition",0,"VisualReporting.Condition",0],[0,"Property",1,"VisualReporting.Property",0],[0,"Type",0,0],[0,"UserPrompt",1,0],[0,"Value",1,0]],[[["childCondition"],"IsChildCondition",{R_:{isChild:''}},1,0],[["index"],"GetChildCondition",{R_:{childCondition:"VisualReporting.Condition"}},1,0],[["numConditions"],"GetChildConditions",{R_:{childConditions:"VisualReporting.Condition[]"}},0,0]],[]];
SPLM.VisualReporting.Condition = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.VisualReporting.Condition";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.VisualReporting.Condition.TypeOption = Object.freeze({
    "AndCondition" : "AndCondition", "OrCondition" : "OrCondition", "NotCondition" : "NotCondition", "ValueCondition" : "ValueCondition"});

SPLM.VisualReporting.Condition.OperatorOption = Object.freeze({
    "EqualOperator" : "EqualOperator", "LessThanOperator" : "LessThanOperator", "NotLessThanOperator" : "NotLessThanOperator", "GreaterThanOperator" : "GreaterThanOperator", "NotGreaterThanOperator" : "NotGreaterThanOperator", "NotEqualOperator" : "NotEqualOperator", "RegularExpressionOperator" : "RegularExpressionOperator", "ContainsOperator" : "ContainsOperator", "DoesNotContainOperator" : "DoesNotContainOperator", "OnOrBeforeOperator" : "OnOrBeforeOperator", "OnOrAfterOperator" : "OnOrAfterOperator"});

export default SPLM;